export default "__VITE_ASSET__65ed5785__"